import { Injectable, inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs/internal/Observable';
import { HttpClient } from '@angular/common/http';
import { Kundenbetreuer } from '../../domain/model/kundenbetreuer';

@Injectable({
    providedIn: 'root',
})
export class KundenbetreuerService {
    private http = inject(HttpClient);

    public getAllKundenbetreuer(): Observable<Kundenbetreuer[]> {
        return this.http.get(environment.API_URL + '/admin/kundenbetreuer') as Observable<Kundenbetreuer[]>;
    }

    public getKundenbetreuer(id: number): Observable<Kundenbetreuer> {
        return this.http.get(environment.API_URL + '/admin/kundenbetreuer/' + id) as Observable<Kundenbetreuer>;
    }

    public saveKundenbetreuer(kundenbetreuer: Kundenbetreuer): Observable<Kundenbetreuer> {
        return this.http.put(environment.API_URL + '/admin/kundenbetreuer/' + kundenbetreuer.id, kundenbetreuer) as Observable<Kundenbetreuer>;
    }

    public createKundenbetreuer(kundenbetreuer: Kundenbetreuer): Observable<Kundenbetreuer> {
        return this.http.post(environment.API_URL + '/admin/kundenbetreuer', kundenbetreuer) as Observable<Kundenbetreuer>;
    }

    public saveAllKundenbetreuer(kundenbetreuerList: Kundenbetreuer[]): Observable<Kundenbetreuer[]> {
        return this.http.put(environment.API_URL + '/admin/kundenbetreuer', kundenbetreuerList) as Observable<Kundenbetreuer[]>;
    }

    public deleteKundenbetreuer(kundenbetreuer: Kundenbetreuer): Observable<any> {
        return this.http.delete(environment.API_URL + '/admin/kundenbetreuer/' + kundenbetreuer.id) as Observable<any>;
    }
}
